import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';

function initializeKeycloak(keycloak: KeycloakService) {
    return () =>
        keycloak.init({
            config: {
                url: environment.URL_KEY_CLOACK,
                realm: environment.REALM,
                clientId: environment.CLIENT_ID,
            },
            initOptions: {
                onLoad: 'check-sso',
                checkLoginIframe: false,
                silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
            },
            bearerExcludedUrls: Object.values(environment.urlsApi),
        });
}

@NgModule({
    declarations: [],
    imports: [KeycloakAngularModule],
    exports: [],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeKeycloak,
            multi: true,
            deps: [KeycloakService],
        },
    ],
})
export class AuthModule {}
